export default {
  bandeauConfiguration: {
    default: 'Configuration du bandeau',
    bandeau_text: 'Texte',
    bandeau_expiry: "Date d'expiration du bandeau",
    bandeau_enabled: 'Activer'
  }
}
